import { ISvgComponent } from '../../svg.models';
import * as S from '../svg.style';

export const CircleStatusSuccess: React.FC<ISvgComponent> = ({
  color = '#008A00',
  height,
  width,
  shrinkable,
  ...rest
}) => (
  <S.Svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height={height}
    width={width}
    viewBox="0 0 20 20"
    shrinkable={shrinkable}
    {...rest}
  >
    <circle cx="10" cy="10" r="10" fill={color} />
    <path d="M 15,7 8.0720,13 5,10.332" stroke="white" strokeLinecap="round" />
  </S.Svg>
);
